import React from "react";
import { Modal, Box, Typography, CircularProgress } from "@mui/material";
import * as styles from "../styles/BackendLoadingModal.style";

interface BackendLoadingModalProps {
  isLoading: boolean;
  message?: string;
  delayMs?: number;
}

function BackendLoadingModal({
  isLoading,
  message,
  delayMs = 5000
}: BackendLoadingModalProps) {
  const [showModal, setShowModal] = React.useState(false);

  // Show modal only if loading state persists for more than delayMs
  React.useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isLoading) {
      timer = setTimeout(() => {
        setShowModal(true);
      }, delayMs);
    } else {
      setShowModal(false);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isLoading, delayMs]);

  return (
    <Modal
      open={showModal}
      sx={styles.backendLoadingModal}
      slots={{ backdrop: Backdrop }}
      disableEscapeKeyDown
      disableAutoFocus
    >
      <Box sx={styles.loadingBox}>
        <CircularProgress size={60} thickness={4} color="primary" />
        <Typography variant="h6" sx={styles.loadingTitle}>
          {message || "Connecting to server..."}
        </Typography>
        <Typography variant="body2" sx={styles.loadingSubtext}>
          Our backend is waking up. This may take up to a minute.
        </Typography>
        <Typography variant="caption" sx={styles.loadingHint}>
          Thanks for your patience!
        </Typography>
      </Box>
    </Modal>
  );
}

function Backdrop(props: any) {
  const { ownerState, ...rest } = props;
  return <Box style={styles.modalBackdrop} {...rest} />;
}

export default BackendLoadingModal;
